import React from 'react';
import { string, node } from 'prop-types';

import './list-header-title-h5.m.css';
import { BQLink } from '../bqlink';

const titleWithIconCode = ({ children, title, iconCode }) => (
  <h5 styleName="list-header-title" className="list-header-title truncate-overflow" style={{ fontSize: '24px', display: 'inline-flex', padding: "4px 14px" }}>
    {iconCode ? (
      <div styleName="icon-container">
        <i
          className={iconCode}
          style={{
            fontSize: `var(--base-medium)`,
            color: `var(--font4-color)`
          }}
        />
      </div>
    ) : (
      children
    )}
    {title === 'All News' ? <span styleName="allNews-style">{title}</span> : title}
  </h5>
);
const ListHeaderTitleh5 = ({ width, height, href, iconCode, iconSize, iconColor, ...props }) => (
  <>
    {href ? (
      <BQLink href={href}>{titleWithIconCode({ ...props, iconCode, iconSize, iconColor })}</BQLink>
    ) : (
      <>{titleWithIconCode({ ...props, iconCode, iconSize, iconColor })}</>
    )}
  </>
);

ListHeaderTitleh5.propTypes = {
  width: string,
  height: string,
  href: string,
  iconCode: string,
  iconSize: string,
  iconColor: string,
  children: node,
  title: string,

};

ListHeaderTitleh5.defaultProps = {
  children: null,
  title: '',
  iconCode: null
};

export default ListHeaderTitleh5;
